import { StripeAccountName, stripeAccountNameSchema } from '@inkitt/contracts-common';
import { zodParseV2 } from '@inkitt/utils-parse';

export const convertStringToStripeAccountName = ({
  account,
  defaultAccount,
}: {
  account?: string | null;
  defaultAccount: StripeAccountName;
}): StripeAccountName => {
  if (isStripeAccountName(account)) {
    return account;
  }

  return defaultAccount;
};

export const isStripeAccountName = (account?: string | null): account is StripeAccountName => {
  const { data } = zodParseV2(stripeAccountNameSchema, account);
  return !!data;
};
